<script>
    import R, {LOADER} from "../lib/requests";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import Pagination from "../components/Pagination.svelte";
    import {formatDate} from "../lib/lib.js";

    const tableColumns = [
        {key: 'object_id', title: 'SUBJECT', sortable: true},
        {key: 'action', title: 'ACTION', sortable: true},
        {key: 'description', title: 'DESCRIPTION', sortable: false},
        {key: 'created_at', title: 'DATE', sortable: true, sort_way: 'DESC'},
        {key: 'completed_at', title: 'COMPLETED', sortable: true},
    ];

    const pageHeaderControls = [
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const itemsPerPage = [20, 50, 100, 500, 1000];

    let search = {
        limit: 50,
        offset: 0,
        sort_field: null,
        sort_way: null,
    }
    let page = 1;
    let list = null;
    let total = null;
    let selectedId = null;

    const load = (loader = LOADER.POPUP) => {
        const onSuccess = result => {
            list = result.list;
            total = result.total;
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;

        R.handle(R.actionRequests.index, search, onSuccess, onFailure, loader);
    }

    const onColumnSort = ({detail}) => {
        search.sort_field = detail.key;
        search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        page = detail;
        load();
        scrollTo('listing-top', -50);
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    load();
</script>

<PageHeader title="Action Requests" controls={ pageHeaderControls } on:reload={ load }/>

<div class="row align-items-center mb-4" id="listing-top">
    <div class="col-xl-2 col-lg-3 col-md-4 col-7">
        <select class="form-select form-select-sm" bind:value="{ search.limit }" on:change="{ onSearch }">
            {#each itemsPerPage as item}
                <option value="{ item }">view { item } / page</option>
            {/each}
        </select>
    </div>
    {#if list && list.length}
        <div class="col-xl-10 col-lg-9 col-md-8 col-5">
            <span class="listing-info">Entries: <strong>{ total }</strong></span>
            <span class="listing-info hidden-xs">Page: <strong>{ page }</strong></span>
        </div>
    {/if}
</div>

{#if list}
    {#if list.length}
        <table class="table table-list members-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each list as item}
                <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                    <td>
                        { item.subject }
                    </td>
                    <td class="text-gray">
                        { item.action }
                    </td>
                    <td class="text-gray">
                        { item.description }
                    </td>
                    <td class="date-column text-gray">
                        { formatDate(item.created_at, 'd-m-y') }
                    </td>
                    <td class="date-column text-gray">
                        { formatDate(item.completed_at, 'd-m-y') }
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ search.limit }" totalItems="{ total }" page="{ page }"
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel-simple panel-pad">
            No requests found.
        </div>
    {/if}
{/if}